import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import MarginHistoryOrderData = ww.MarginHistoryOrderData;
import Msg = ww.Msg;

export const historyOrders$ = new BehaviorSubject<MarginHistoryOrder[]>([]);

wwData$.pipe(filter((o: Msg<MarginHistoryOrderData>) => o.type === 'margin-orders-history')).subscribe((msg: Msg<MarginHistoryOrderData>) => historyOrders$.next(msg.data.orders));
